import React from "react";
import { connect } from "react-redux";

import {
  getStudentDinnerBookingIDList,
  getStudentSchoolID,
  getSchoolByStudentID,
  isDinnersEnabled,
  isDinnerTopUpsEnabled,
  getGoToDinnerBookingID,
  canStudentDoDinnerTopUp,
  isExternalTopUpEnabled,
  isXodActive,
  doesStudentUseExternalCashless,
  doesStudentHasMisId
} from "state/school_money/selectors";
import { clearGoToDinnerBooking } from "state/school_money/actions";

import ScrollableList from "components/ScrollableList";
import List from "components/List";
import PlaceholderCard from "components/school_money/PlaceholderCard";
import StudentCreditBalance from "components/school_money/StudentCreditBalance";
import DinnerCreditTopUp from "components/school_money/dinners/DinnerCreditTopUp";
import DinnerBooking from "components/school_money/dinners/DinnerBooking";

class StudentDinnersList extends React.Component {

  render() {

    const { studentID, dinnerBookingIDList, isDinnersEnabled, isTopUpsEnabled, school, canStudentTopUp,
      isExternalTopUpEnabled, isXodActive, isExternal, studentHasMisId } = this.props;

    const placeholder = isExternal ? <PlaceholderCard objectName={"dinner bookings"} school={school} message={"Top Ups are currently unavailable."} /> : <PlaceholderCard objectName={"dinner bookings"} school={school} />;
    const footerMessage = "The Dinner Balance can take a while to update. The amount displayed may not accurately reflect the current balance.";

    return (
      <ScrollableList className="dinners-list" scrollTargetID={this.props.goToDinnerBookingID} onScroll={this.props.clearGoTo}>
        { refChild => (
          isExternal ?
          <React.Fragment>
            <StudentCreditBalance studentID={studentID} type="dinner_money" />
            {
              (isExternalTopUpEnabled && isXodActive && studentHasMisId) ? <DinnerCreditTopUp studentID={studentID} /> : placeholder
            }
            <div className="dinners-list___footer">{ footerMessage }</div>
          </React.Fragment>
          :
          (isDinnersEnabled) ?
          <React.Fragment>
            <StudentCreditBalance studentID={studentID} type="dinner_money" />
            {
              (isTopUpsEnabled && canStudentTopUp) ?
              <DinnerCreditTopUp studentID={studentID} /> :
              <List placeholder={placeholder}>
                {
                  dinnerBookingIDList.map(dinnerBookingID => (
                    <DinnerBooking
                      key={dinnerBookingID}
                      dinnerBookingID={dinnerBookingID}
                      innerRef={child => refChild(child, dinnerBookingID)}
                    />
                  ))
                }
              </List>
            }
          </React.Fragment> :
          placeholder
        ) }
      </ScrollableList>
    );

  }

}

export default connect(
  (state, { studentID }) => ({
    dinnerBookingIDList: getStudentDinnerBookingIDList(state, studentID),
    isDinnersEnabled: isDinnersEnabled(state, getStudentSchoolID(state, studentID)),
    isTopUpsEnabled: isDinnerTopUpsEnabled(state, getStudentSchoolID(state, studentID)),
    school: getSchoolByStudentID(state, studentID),
    goToDinnerBookingID: getGoToDinnerBookingID(state),
    canStudentTopUp: canStudentDoDinnerTopUp(state, studentID),
    isExternalTopUpEnabled: isExternalTopUpEnabled(state, getStudentSchoolID(state, studentID)),
    isXodActive: isXodActive(state, getStudentSchoolID(state, studentID)),
    isExternal: doesStudentUseExternalCashless(state, studentID),
    studentHasMisId: doesStudentHasMisId(state, studentID)
  }),
  {
    clearGoTo: clearGoToDinnerBooking
  }
)(StudentDinnersList);



// WEBPACK FOOTER //
// ./src/components/school_money/dinners/StudentDinnersList.js